import React from 'react';

// Unique, non-templated Invelitio mark: three stacked geologic strata (deep blue)
// crossed by a thin vertical drill line (mineral gray) with a terracotta project node.
export function LogoMark({ size = 28, className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      aria-hidden="true"
      role="img"
    >
      <rect x="3" y="6" width="20" height="4" rx="1" fill="hsl(214 78% 18%)" />
      <rect x="6" y="14" width="20" height="4" rx="1" fill="hsl(214 70% 30%)" />
      <rect x="3" y="22" width="20" height="4" rx="1" fill="hsl(214 60% 42%)" />
      <rect x="25" y="3" width="1.6" height="22" rx="0.8" fill="hsl(215 12% 48%)" />
      <circle cx="25.8" cy="26" r="2.6" fill="hsl(18 62% 46%)" />
    </svg>
  );
}

export function Logo({ withText = true, className = '' }) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <LogoMark size={28} />
      {withText && (
        <span className="flex flex-col leading-none">
          <span className="font-heading text-lg font-semibold tracking-tight text-[hsl(var(--inv-slate))]">
            Invelitio
          </span>
          <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-muted-foreground">
            Argentina
          </span>
        </span>
      )}
    </span>
  );
}

export default Logo;
